export default "__VITE_ASSET__CQxj8sjh__"